import {Formik} from "formik";
import {useCallback, useContext, useState} from "react";
import {SessionUserContext, TSessionUser} from "../../context/UserContext";
import PlacesAutocomplete, {geocodeByPlaceId} from 'react-places-autocomplete';
import {API_URL, convertAddressComponents} from "../../utils";
import {FormikHelpers} from "formik/dist/types";

const Step1 = () => {

    const userContext = useContext(SessionUserContext)
    const [address, setAddress] = useState<string>('')


    const onSubmit = useCallback(async (values: any, formHelper: FormikHelpers<TSessionUser>) => {


        if (!values.address || values.address === '' || typeof values.address !== 'object') {

            formHelper.setFieldError('address', 'Please select an address from the dropdown')
            return false
        }

        if (values.name === '' || values.phone === '') {

            formHelper.setErrors(
                {name: 'Please enter your name', phone: 'Please enter your  phone number'}
            )
            return false
        }
        const phone = values.phone.replace(/[^0-9]/g, '')

        formHelper.setFieldValue('phone', phone)

        const options: any = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({...values, phone})
        };


        await fetch(API_URL + '/user', options)
            .then(response => response.json())
            .then(response => {

                if (response.customer.id) {
                    userContext.setUser(response.customer)
                }

                if (response?.propertyData?.num_found > 0) {
                    let areaInSqFt = 0
                    if (!(typeof response.propertyData.records[0].lotSizeUnit === 'string')) {
                        return;
                    }
                    if (response.propertyData.records[0].lotSizeUnit.startsWith('sq')) {
                        areaInSqFt = response.propertyData.records[0].lotSizeValue
                    } else if (response.propertyData.records[0].lotSizeUnit.startsWith('ac')) {
                        areaInSqFt = response.propertyData.records[0].lotSizeValue * 43560
                    }
                    if (areaInSqFt > 0) {
                        userContext.setPropertySize(areaInSqFt)
                    }

                }
            })
            .catch(err => console.error(err));

        return true
    }, [userContext])


    return (
        <div className={"uk-card uk-card-body uk-card-small"}
             style={{
                 background: 'rgba(0,0,0,0.1)',
             }}
        >
            <p className={"uk-text-lead"}>
                Get a quick and easy price:
            </p>

            <Formik<TSessionUser>
                initialValues={{
                    name: (new URL(window.location.href)).searchParams.get('cName') || '',
                    address: '',
                    phone: (new URL(window.location.href)).searchParams.get('phone') || ''
                }} onSubmit={onSubmit}>
                {({
                      handleBlur,
                      handleChange,
                      values,
                      handleSubmit,
                      getFieldHelpers,
                      errors,
                      isSubmitting,
                      touched
                  }) => (<form onSubmit={handleSubmit} className="uk-grid uk-grid-column-collapse uk-grid-row-small"
                               data-uk-grid>
                    <div className="uk-width-expand">

                        <PlacesAutocomplete
                            value={address}
                            onChange={(ev) => {
                                if (ev === '') {
                                    getFieldHelpers('address').setValue(ev)
                                }
                                setAddress(ev)
                            }}
                            onSelect={(ev, placeID) => {


                                setAddress(ev)
                                getFieldHelpers('address').setValue(ev)

                                geocodeByPlaceId(placeID)
                                    .then(results => {
                                        userContext.setLocation(results[0])
                                        const addressComponent = convertAddressComponents(results[0].address_components)
                                        getFieldHelpers('address').setValue({
                                            line1: `${addressComponent.street_number} ${addressComponent.route}`,
                                            city: addressComponent.city,
                                            state: addressComponent.state,
                                            postal_code: addressComponent.postal_code,
                                            country: addressComponent.country
                                        })

                                    })
                                    .catch(error => console.error(error));
                            }}
                        >
                            {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                                <div className={"uk-position-relative"} style={{zIndex: 1}}>
                                    <input
                                        {...getInputProps({
                                            placeholder: 'Your Address',
                                        })}
                                        name={"address"}
                                        autoComplete={"off"}
                                        className="uk-input"
                                        onBlur={handleBlur}
                                    />
                                    <div className="uk-position-absolute" style={{
                                        top: '100%',
                                        background: '#fff',
                                    }}>
                                        {/*{loading && <div>Loading...</div>}*/}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? {backgroundColor: '#fafafa', cursor: 'pointer'}
                                                : {backgroundColor: '#ffffff', cursor: 'pointer'};
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                        style,
                                                    })}
                                                >
                                                    <span style={{
                                                        display: 'block',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'ellipsis',
                                                        padding: '0.5rem'
                                                    }}>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                        {touched.address && errors.address ?
                            <div className="uk-text-danger">{errors.address}</div> : null}

                    </div>

                    <div className="uk-width-1-4@s" hidden={values.address === ''}>
                        <input
                            className="uk-input"
                            name={"name"}
                            placeholder={"Your Name"}
                            type="text"

                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                        />
                        {touched.name && errors.name ?
                            <div className="uk-text-danger">{errors.name}</div> : null}
                    </div>

                    <div className="uk-width-1-4@s" hidden={values.address === ''}>
                        <input
                            className="uk-input"
                            name={"phone"}
                            placeholder={"Your phone"}
                            type="text"

                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                        />
                        {touched.phone && errors.phone ?
                            <div className="uk-text-danger">{errors.phone}</div> : null}
                    </div>

                    <div className="uk-width-1-4@s">
                        <button
                            className="uk-button uk-button-primary uk-width-1-1"
                            type="submit"
                        >
                            {isSubmitting ? <div data-uk-spinner></div> : 'Get A Price'}
                        </button>
                    </div>
                    <div className={"uk-width-1-1"}>
                        <p className={"uk-flex uk-flex-middle uk-text-primary uk-text-center uk-flex-center"}><span
                            data-uk-icon={"icon:lock;ratio:0.8"}></span> Your Information is Secure</p>
                    </div>
                </form>)}
            </Formik>
        </div>
    );
}
export default Step1;